import { Grid, Step, StepLabel, Stepper } from "@mui/material";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import BasvuruFormuBlokservice from "../../../service/Ebasvuru/AdayDomain/BasvuruFormuBlokService";
import DynamicTabComponent from "../../../components/menu/DynamicTabComponent";
import BoxContainer from "../../../components/container/BoxContainer";
import BlokerComponent from "./BlokerComponent";
import { ShareProvider, useShareContext } from "./BasvuruContext";
import BasvurProfile from "./Profile";
import AdayPage from "../Adaylar/AdayPage";
import useMessage from "../../../util/useMessagev2";
import useGlobal from "../../../util/Global";
import Basvurularservice from "../../../service/Ebasvuru/BasvurularService";
import BasvuruStatus from "./BasvuruStatus";
import AdayBasvurularservice from "../../../service/Ebasvuru/AdayBasvurularService";
import Projesiservice from "../../../service/Ebasvuru/AdayDomain/ProjesiService";
import { CustomStepper } from "./Component/CustomStepper";
import { useMobileView } from "../../../util/useMobileView";


const useBasvurularData = (user) => {

    const [project, setProject] = useState({});
    const [blokler, setBlokler] = useState([]);
    const [basvurForm, setBasvurForm] = useState();


    useEffect(async () => {
        if (!user) return;

        const fetchAll = async () => {

            const [pRes, bRes, aRes] = await Promise.all([
                Projesiservice.fullGet({ filter: { id: user.iapId } }),
                BasvuruFormuBlokservice.fullGet({
                    filter: { basvuruFormuId: user.basvuruId, aktif: true },
                    order: [{ key: "siralama", value: "asc" }]
                }),
                AdayBasvurularservice.fullGet({
                    filter: {
                        adayId: user?.user?.userId,
                        iapId: user?.iapId
                    }
                })
            ])

            if (pRes?.isSuccess) { setProject(pRes.resultObject[0]); }
            if (bRes?.isSuccess) {
                setBlokler(
                    bRes.resultObject.map(b => ({
                        id: b.id,               // Unique identifier
                        display: b.display || b.adi // Display name
                    })))
            }
            if (aRes.isSuccess) { setBasvurForm(aRes?.resultObject[0]); }

        }
        fetchAll();

    }, [user]);


    return { project, blokler, basvurForm };
}

const BasvuruForm = () => {

    const message = useMessage();
    const user = useSelector(user => user.auth);
    const { getKriterler, BasvuruFormuBlokZorunlu, isClose, setClosed, isPageValid } = useShareContext();


    const [selBlok, setSelBlok] = useState(0);

    const { project, blokler, basvurForm } = useBasvurularData(user);

    const { t } = useGlobal();



    const validateAndProceed = async (callback) => {
        const result = await BasvuruFormuBlokZorunlu(); // Await the result
        if (!result.isValid) {
            message.error(`${t("message.ZorunluAlanlarDoldurun")}`);
            return;
        }
        callback(); // Execute the passed function if validation succeeds
    };

    const moveBlokler = async (isNext) => {

        /// validation just when move ileri 
        if (isNext) {
            validateAndProceed(() => {
                const selectedIndex = blokler.findIndex(blok => Number(blok.id) === Number(selBlok));

                if (isNext) {
                    const nextBlok = blokler[selectedIndex + 1];
                    if (nextBlok) setSelBlok(nextBlok.id);
                } else {
                    const prevBlok = blokler[selectedIndex - 1];
                    if (prevBlok) setSelBlok(prevBlok.id);
                }
            });
        } else {
            /// just move wihtout validation 
            const selectedIndex = blokler.findIndex(blok => Number(blok.id) === Number(selBlok));
            const prevBlok = blokler[selectedIndex - 1];
            if (prevBlok) setSelBlok(prevBlok.id);
        }


    };

    const moveBloklerTree = async (e) => {
        // return;
        validateAndProceed(() => setSelBlok(e));
    };

    const isLastMove = () => {
        const isLastBlok = blokler.length > 0 && Number(selBlok) === Number(blokler[blokler.length - 1]?.id);
        return isLastBlok;
    }

    useEffect(() => {

        if (basvurForm && basvurForm?.durum !== 0) {
            setClosed(true);
        }
    }, [basvurForm]);

    useEffect(() => {
        let isMounted = true;
        getKriterler();
        return () => {
            isMounted = false; // Cleanup: Prevent state update after unmount
        };
    }, []);

    const getSelectedIndex = () => {
        const selectedIndex = blokler.findIndex(blok => Number(blok.id) === Number(selBlok));
        return selectedIndex;
    }

    const getBlokerComponent = () => {
        if (selBlok == "0")
            return <BasvurProfile
                basvuruFormuId={user.basvuruId}
                moveBlokler={moveBlokler}
                isFinish={isLastMove()}
            />

        return <BlokerComponent
            basvuruFormBlokId={selBlok}
            moveBlokler={moveBlokler}
            isFinish={isLastMove()}
        />
    }

    const filterContent = (
        <Grid item xs={12} md={5} lg={3} >
            <DynamicTabComponent
                tabOptions={blokler}
                selectedTab={selBlok}
                disabled={isClose}
                onTabChangeEvent={(e) => { moveBloklerTree(e); toggleDrawer() }}
                title={project?.isAciklamasi}
            >

            </DynamicTabComponent>
        </Grid>
    );

    const {
        isMobile,
        mobileContext,
        toggleDrawer } = useMobileView(filterContent);


    return (
        <AdayPage menuAction={(isMobile && mobileContext)}>
            <Grid container spacing={2} >
                {!isMobile && filterContent}
                <Grid item xs={12} md={7} lg={9}>

                    <BoxContainer color="light" boxSx={{ pt: 3 }}>
                        <CustomStepper steps={blokler} activeStep={getSelectedIndex()}></CustomStepper>
                        {isClose ? <BasvuruStatus BasvurForm={basvurForm} /> : getBlokerComponent()}

                    </BoxContainer>
                </Grid>
            </Grid>
        </AdayPage>

    )
}

export default BasvuruForm;